import { render, staticRenderFns } from "./GreenExpenseForm.vue?vue&type=template&id=213d3838&scoped=true&"
import script from "./GreenExpenseForm.vue?vue&type=script&lang=js&"
export * from "./GreenExpenseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d3838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('213d3838')) {
      api.createRecord('213d3838', component.options)
    } else {
      api.reload('213d3838', component.options)
    }
    module.hot.accept("./GreenExpenseForm.vue?vue&type=template&id=213d3838&scoped=true&", function () {
      api.rerender('213d3838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/GreenExpenseForm.vue"
export default component.exports